export default __webpack_public_path__ + "static/media/50-min.285544c1.jpg";